import { getProductGallery } from './productGallery';
import { t } from './i18n';

const DEFAULT_OG_IMAGE = 'https://estumejoropcion.com/og-image.png';

function siteBaseUrl() {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv) return String(fromEnv).replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }
  return 'https://estumejoropcion.com';
}

export function resolveMediaUrl(url) {
  const value = String(url || '').trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  const base = value.startsWith('/api/') && process.env.REACT_APP_API_URL
    ? String(process.env.REACT_APP_API_URL).replace(/\/$/, '')
    : siteBaseUrl();
  return value.startsWith('/') ? `${base}${value}` : `${base}/${value}`;
}

export function parseGalleryImages(product) {
  const raw = product?.gallery_images;
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map((v) => String(v || '').trim()).filter(Boolean);
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map((v) => String(v || '').trim()).filter(Boolean) : [];
    } catch {
      return [];
    }
  }
  return [];
}

export function buildProductGalleryItems(product, slug, language) {
  const items = [];
  const seen = new Set();
  const push = (url, alt) => {
    const src = resolveMediaUrl(url);
    if (!src || seen.has(src)) return;
    seen.add(src);
    items.push({ src, alt: alt || product?.name || '' });
  };

  const primary = product?.primary_image_url?.trim();
  if (primary) push(primary, product?.name || '');
  parseGalleryImages(product).forEach((url) => push(url, product?.name || ''));

  if (items.length) return items;

  return getProductGallery(slug).map((item) => ({
    src: resolveMediaUrl(item.src),
    alt: t(item.altKey, language)
  }));
}

export function getProductOgImageUrl(product, slug) {
  if (product?.primary_image_url) return resolveMediaUrl(product.primary_image_url);
  const gallery = parseGalleryImages(product);
  if (gallery[0]) return resolveMediaUrl(gallery[0]);
  const staticItems = getProductGallery(slug);
  if (staticItems[0]?.src) return resolveMediaUrl(staticItems[0].src);
  return DEFAULT_OG_IMAGE;
}

export function getProductGalleryThumb(product, slug, language) {
  const items = buildProductGalleryItems(product, slug, language);
  return items[0] || null;
}
